

exports.__esModule = true;
exports.$xoSidebarAddNewPageComponent = undefined;

var _angular = require('angular');

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _auth = require('xo-models/src/auth');

var _index = require('xo-models/src/checkout/index');

var _fiMessages = require('xo-models/src/fi/lib/fiMessages');

require('xo-page-components/src/aside-header/directive');

require('xo-page-components/src/value-props/directive');

require('xo-ui-components/src/dropdown/directive');

require('xo-ui-components/src/tooltip/directive');

require('xo-validation/dist/directive');

require('xo-wallet-components/src/add-card/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidebarAddNewPageComponent = exports.$xoSidebarAddNewPageComponent = _squid.$Component.extend('$xoSidebarAddNewPageComponent', {
    tag: 'xo-sidebar-add-new-page',
    template: _template2['default'],
    scope: {},
    controller: ['$scope', function ($scope) {
        $scope.sidebar = true;
        // TODO: refactor controller logic to use lifecycle() methods
        $scope.token = _angular.$rootScope.token;
        $scope.locale = _squid.$locale;
        $scope.hideparenthead = {
            toggle: false
        };
        $scope.callbacks = {
            finish: function finish() {
                return _uiRouter.$state.go('checkout.review');
            },
            done: function done() {
                return _uiRouter.$state.go('checkout.review');
            },
            cancel: function cancel(routeTo) {
                var destination = routeTo || $scope.parentState || '';

                if (destination) {
                    _uiRouter.$state.go(destination);
                }
            }
        };

        // TODO: remove nested $populate() logic to `resolve` and `lifecycle`
        var models = {};

        (0, _squid.$populate)($scope, {
            auth: _auth.$AuthModel.instance(),
            payee: _index.$CheckoutPayeeModel.instance($scope.token)
        }).then(function () {
            (0, _squid.$populate)(models, {
                checkoutSession: _index.$CheckoutSessionModel.instance($scope.token)
            }).then(function () {
                (0, _squid.$pxp)('xo_hermes_addcard_msg', { 'ctx.COUNTRY': $scope.locale.country }, 'xo_hermes_addcard_msg_treatment', false, true).then(function (result) {
                    var message = _fiMessages.$fiMessages.processorDeclinedMsg(models.checkoutSession, false);

                    // If no processor decline, retrieve and display the contingency message
                    if (!message && models.checkoutSession.get('errorData.cause')) {
                        if ($scope.payee.isGambling()) {
                            message = _fiMessages.$fiMessages.getGamblingMsg();
                        } else if (result) {
                            message = _fiMessages.$fiMessages.getAddCardTreatmentMsg(models.checkoutSession);
                        } else {
                            message = _fiMessages.$fiMessages.getAddCardControlMsg(models.checkoutSession);
                        }
                    }

                    if (message) {
                        $scope.pageLevel = $scope.pageLevel || {};
                        $scope.pageLevel.message = {
                            type: message.type,
                            msgs: [message.msg]
                        };
                        if (message.title) {
                            $scope.messagetitle = _squid.$locale.content.get(message.title.key);
                        }
                    }
                });
            });
        });
    }]
});

angular.value("$xoSidebarAddNewPageComponent", $xoSidebarAddNewPageComponent);
_angular.$rootScope;

_squid.$Component;

_squid.$locale;

_squid.$populate;

_squid.$pxp;

_uiRouter.$state;

_auth.$AuthModel;

_index.$CheckoutPayeeModel;

_index.$CheckoutSessionModel;

_fiMessages.$fiMessages;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar-add-new/directive.js
// module id = ./pages/xo-sidebar-add-new/directive.js
// module chunks = 0